<template>
  <div class="PetCard">
    <div class="clickable-overlay" @click="gotoPetPage(pet_id)"></div>
    <!-- {{getPetData(pet)}} -->
    <div class="banner-wrapper">
      <ProfileBanner
        :pet_banner="pet_data.banner"
        :editablePage="editablePage"
        :pet_id="pet_id"
        :tag_links="pet_data.tag_links"
        />
  </div>

    <div class="profile-details" >
      <div class="profile-details-left">
      <h2 class="pet-name">{{pet_data.name}}</h2>

      <p class="subtext">{{pet_data.gender}} •
      <span class="no-age-text text-primary"> {{displayPetAge}} </span>•
       <span class="text-primary">{{pet_data.weight}} </span> lbs</p>
      <p class="subtext">My parent is
        <span class="owner-name">{{displayUser}}</span>
      </p>

      <div class="profile-details-location">
        <img class="address-icon" src="@/assets/svg/dog-icons/location.svg" />
        <p v-if="userdata.address.city == '' || userdata.address.state == '' ">Unknown Location</p>
        <p v-else>{{userdata.address.city}}, {{userdata.address.state}}</p>
      </div>
    </div>
    <div class="profile-image" :style="{'background-image': 'url(' + pet_data.photo + ')'}">
      <!-- <input
      v-if="editablePage"
      class="profile-input"
        type="file" accept="image/jpeg, image/png, image/gif"
        @change="selectProfileFile"
        value="0"
         /> -->

      <div class="profile-img-overlay">
        <p>Click To Edit Photo</p>
      </div>
    </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import {fb, db} from '@/_firebase/init'
import {mapState, mapGetters} from 'vuex'
import ProfileBanner from '@/petprofile/components/main/ProfileBanner.vue'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'PetCard',
  components: {
    // 'vue-spinner': ClipLoader,
    ProfileBanner,
  },
  props:['pet_id', 'userdata', 'editablePage'],
  data(){
    return{
      processing: false,
      triggerAlert: true,
      showConfirmModal: false,
      showMoreOptions: false,
      isScanning: false,
      pets_owned: [],
      owner_name: '',
      pet_data:{photo:'', name: '', gallery:[], tag_links:[], bday: '01/01/2000'},
      loading: true,
    }
  },
  methods:{
    showMoreOptionMenu(val){
      this.showMoreOptions = val
    },
    selectProfileFile(evt){
          let file = evt.target.files[0];
          var storeRef = fb.storage().ref('/pet_profile_media/photo/'+file.name);
          let uploadTask = storeRef.put(file);
          uploadTask.on('state_changed', () =>{
          },(err) => {
            console.log(err);
          },() => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.pet_data.photo = downloadURL;
              this.addPetPhoto(downloadURL)
            });
          })
        },
    async addPetPhoto(pic){
      const petRef = db.collection('pets').doc(this.pet_id);
      const res = await petRef.update({photo: pic});
      return res
    },
    gotoRoute(rotue){
      this.$router.push({name: rotue})
    },
    gotoPetPage(pet_id){
      if(this.editablePage == true){
        // this.$router.push({name: 'PetPage', params:{ id: this.userID, pet_id: pet_id}})
        window.open(`/pet/${pet_id}`, '_self')
      }else{
        const other_name = this.$route.params.username
        this.$router.push({name: 'ScannedPage', params:{ username: other_name, pet_id: pet_id}})
      }
    },
    alertMissingPet(){
      this.processing = true
      let payload = {
        pet_location: 'pet located here',
        userID: this.userID
      }
      console.log(payload.pet_location)
      axios.post(this.$api_path + '/api/owner_alert_missing_pet', payload
      ).then((res)=>{
          this.setAlertTimer()
          this.feedback = res.data.feedback
          setTimeout(function(){ this.processing = false }, 1000);
      }).catch((err)=>{
        console.log(err)
      })
    },
    async setAlertTimer(){
      const now = new Date()
      const utc_epoch = Math.round(now.getTime() / 1000)
      const month_in_sec = 2592000
      let alertExpiration = utc_epoch + month_in_sec
      const petRef = db.collection('pets').doc(this.pet_id);
      await petRef.set({
        alertExpiration: alertExpiration
      }, { merge: true })
      this.pet_data['alertExpiration'] = alertExpiration
      this.triggerAlert = false
      console.log(this.triggerAlert)
    },
    getAlertInfo(pet_data){
      const now = new Date()
      const utc_epoch = Math.round(now.getTime() / 1000)
      if(utc_epoch < pet_data.alertExpiration){
        this.triggerAlert = false
      }else{
        this.triggerAlert = true
      }
    },
    timeUntilReactivation(expired_time){
      const now = new Date()
      const utc_epoch = Math.round(now.getTime() / 1000)
      return expired_time - utc_epoch
    },
    async getPetData(pet_id){
      const petRef = db.collection('pets').doc(pet_id);
      const pet_doc = await petRef.get();
      // console.log(pet_doc.data())
      this.pet_data = pet_doc.data()
      this.getAlertInfo(this.pet_data)
    },
  },
  computed:{
    ...mapState([
      'userID'
    ]),
    ...mapGetters(['isAuthenthicated']),
    displayUser(){
      let d_name = this.userdata.username
      if(this.userdata.fname != ''){
        d_name = `${this.userdata.fname } ${this.userdata.lname }`
      }
      return d_name
    },
    displayPetAge(){
      let display_age = ''
      let from = this.pet_data.bday.split("/");
      let birthdateTimeStamp = new Date(from[2], from[0] - 1, from[1]);
      let cur = new Date();
      let diff = cur - birthdateTimeStamp;
      // This is the difference in milliseconds
      let display_day_age = Math.floor(diff/86400000); // in days
      // Divide by 1000*60*60*24*365.25
      if (display_day_age < 7){
        display_age = `${display_day_age} days old`
      }else if(display_day_age >= 7 && display_day_age < 30){
        let week_age = Math.floor(display_day_age/7)
        display_age = `${week_age} weeks old`
      }else if (display_day_age >= 30 && display_day_age < 365.25){
        let month_age = Math.floor(display_day_age/12)
        display_age = `${month_age} months old`
      }else if (display_day_age >= 365.25){
        let year_age = Math.floor(display_day_age/365.25)
        display_age = `${year_age} years old`
      }
      return display_age
    },
  },
  created(){
    this.pets = []
    this.getPetData(this.pet_id)
  },
}
</script>
<style scoped>
.PetCard{
  text-align:center;
  min-height: 20rem;
  width: 99%;
  border: none;
  background-color: #fcfcfc;
  border-radius: 10px;
  margin: 1rem auto;
  padding-bottom: .9rem;
  color: #000;
  position: relative;
  transition: 1s;
  /* -webkit-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  -moz-box-shadow: 14px 12px 52px -22px rgba(110,110,110,1);
  box-shadow: 14px 12px 52px -22px rgba(110,110,110,1); */
}
.banner-wrapper{
  padding: 1.2rem;
  transition: 1s;
}
.clickable-overlay{
  height: 100%;
  width: 100%;
  z-index: 3;
  position: absolute;
  opacity: 0;
  background-color: transparent;
}
.PetCard:hover{
  transform: translateY(-3px);
}
.pet-name{
  font-size: 2rem;
  color: #2d3142;
  font-family: "Altis Bold";
}
.profile-details{
  width: 90%;
  height: 100%;
  margin: 1rem auto;
  margin-top: .24rem;
  /* padding: 1rem; */
  text-align: left;
  transition: 1s;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.subtext{
  font-size: 16px;
  margin: .6rem auto;
  margin: .2rem auto;
  color: #4c5980;
  transition: 1s;
}
.owner-name{
  color: var(--primary);
}
/*----------------------*\
|     PROFILE IMAGE
\*----------------------*/
.profile-image{
  width: 8rem;
  height: 8rem;
  transition:1s;
  border-radius: 10px;
  overflow:hidden;
  position: relative;
  margin-right: -.5rem;
  margin-bottom: -.5rem;
  /* Create the parallax scrolling effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.profile-input:hover .profile-img-overlay{
  opacity: 1;
  cursor:pointer;
}
.profile-image .profile-img-overlay{
  background-color: var(--bg-dark);
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  transform: translateY(-100%);
  border-radius: 100%;
  padding: 0rem;
  /* -ms-transform: translate(-50%, -50%); */
}
.profile-image .profile-img-overlay p{
  color: #fff;
  position: absolute;
  top:50%;
  left:20%;
  font-size: .6rem;
}
.profile-image .profile-input{
  cursor:pointer;
  border: 2px solid #777;
  position: absolute;
  background-color: var(--bg-dark);
  transition: .5s ease;
  border-radius: 100%;
  width: 8.2rem;
  height:8.2rem;
  top: -.5rem;
  left: 0;
  opacity:0;
  z-index:10;
}
/*----------------------*\
|  PROFILE IMAGE END
\*----------------------*/
.address-icon{width: 1rem;}
.profile-details-location{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 2px;
  transition:1s;
  font-size: 12px;
}
.profile-details-location p{
  color: #4c5980;
  font-size: 1.1rem;
  margin: .3rem;
}
.profile-details h4{color: #000; font-size: .9rem; margin: .2rem auto;}

body[data-theme='dark']  .PetCard{
  background-color: #555;
  color: #fff;
}
@media only screen and (max-width: 600px) {
  .PetCard{min-height: 13rem;  width: 330px; padding-bottom: 0;}
  .pet-name{
    font-size: 1.2rem;
  }
  .banner-wrapper{
    padding: .5rem;
  }
  .profile-image{
    width: 5rem;
    height: 5rem;
  }
  .profile-image .profile-input{
    width: 6rem;
    height: 6rem;
  }
  .subtext{
    font-size: 15px;
    margin: .2rem auto;
  }
  .profile-details-location{
    transition:1s;
    /* margin: 0 .2rem; */
  }
  .profile-details-location p{font-size: .8rem; }
  .address-icon{
    width: .7rem;
  }

  .profile-details h4{font-size: .7rem; margin: .2rem auto;}

}
</style>
